import { render, staticRenderFns } from "./CheckboxSelectionCard.vue?vue&type=template&id=5912511a&scoped=true&lang=pug&"
import script from "./CheckboxSelectionCard.vue?vue&type=script&lang=js&"
export * from "./CheckboxSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxSelectionCard.vue?vue&type=style&index=0&id=5912511a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5912511a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VIcon,VSimpleTable})
